/* eslint-disable react-refresh/only-export-components */
import { PropsWithChildren, createContext, useMemo, useState } from 'react';

interface HelpSupportContextValue {
  open: boolean;
  initialIssueType?: string;
  handleOpen: (isOpen: boolean, issueType?: string) => void;
}

export const HelpSupportContext = createContext<HelpSupportContextValue>({
  open: false,
  initialIssueType: undefined,
  handleOpen: () => {},
});

const HelpSupportProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [open, setOpen] = useState<boolean>(false);
  const [initialIssueType, setInitialIssueType] = useState<string | undefined>(
    undefined,
  );

  const value = useMemo(
    () => ({
      open,
      initialIssueType,
      handleOpen: (isOpen: boolean, issueType?: string) => {
        setOpen(isOpen);
        if (isOpen) {
          setInitialIssueType(issueType);
        }
      },
    }),
    [open, initialIssueType],
  );

  return (
    <HelpSupportContext.Provider value={value}>
      {children}
    </HelpSupportContext.Provider>
  );
};

export default HelpSupportProvider;
